import { Directive, Input, ContentChild } from '@angular/core';
import { NglDatatableCell } from './cell';
import { NglDatatableHeadingTemplate } from './heading';
import { toBoolean } from '../util/util';
var NglDatatableColumn = (function () {
    function NglDatatableColumn() {
        this._sortable = false;
    }
    Object.defineProperty(NglDatatableColumn.prototype, "sortable", {
        get: function () {
            return this._sortable;
        },
        set: function (sortable) {
            this._sortable = toBoolean(sortable);
        },
        enumerable: true,
        configurable: true
    });
    NglDatatableColumn.decorators = [
        { type: Directive, args: [{
                    selector: 'ngl-datatable-column',
                },] },
    ];
    /** @nocollapse */
    NglDatatableColumn.ctorParameters = function () { return []; };
    NglDatatableColumn.propDecorators = {
        'heading': [{ type: Input },],
        'key': [{ type: Input },],
        'headClass': [{ type: Input },],
        'cellClass': [{ type: Input },],
        'cellTpl': [{ type: ContentChild, args: [NglDatatableCell,] },],
        'headingTpl': [{ type: ContentChild, args: [NglDatatableHeadingTemplate,] },],
        'sortable': [{ type: Input },],
    };
    return NglDatatableColumn;
}());
export { NglDatatableColumn };
;
//# sourceMappingURL=column.js.map